module.exports = __webpack_public_path__ + "static/media/pen.71c5fec4.svg";